/****************************************************
 * Module Name:  mixReportPurchaseMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import { DataGridPro, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Box, Tooltip, Typography } from "@mui/material";
import Select from "react-select";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import Utility from "../../utility/utility";
import { useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Constants from "../../utility/constants";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import MixBucketProxy from "../../utility/proxy/manager/mixProxy/mixBucketProxy";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import MixPurchaseProxy from "../../utility/proxy/manager/mixProxy/mixPurchaseProxy";
import UserProxy from "../../utility/proxy/manager/userProxy";
import { MultiSelect } from "../common/reactSelectWithSelectAll";
import { LoadingButton } from "@mui/lab";
import CommonSnackbar from "../common/commonSnackBar";
import NoPermission from "../common/noPermission";
import dayjs from "dayjs";
import PageTitle from "../common/pageTitle";

const MixReportPurchaseMaster = () => {
  const [bucket, setBucket] = useState([]);
  const [bucketOption, setBucketOption] = useState([]);
  const [sourceData, setSourceData] = useState([]);
  const [purchaseListListLoader, setPurchaseListListLoader] = useState(false);
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [customer, setCustomer] = useState([]);
  const [customerOption, setCustomerOption] = useState([]);
  const [access, setAccess] = useState(false);
  const [fetchData, setFetchData] = useState(false);
  // eslint-disable-next-line
  const [local_Permission, setLocal_Permission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid ===
        Constants.PERMISSIONS.OPERATION_LAB_REPORTRECEIVED
    )
  );

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [qtyPermission, setQtyPermission] = useState(false);
  const [filterValues, setFilterValues] = useState({});

  let date = new Date(); //Current Date and Time

  useEffect(() => {
    PageTitle("MIX_REPORT_PURCHASE");
    checkPermission()
  }, []);

  const checkPermission = () => {
    let allowed = Constants.USER_PERMISSION.find(
      (iPermission) =>
        iPermission.permissionid ===
        Constants.PERMISSIONS.MIX_REPORT_PURCHASE
    ) !== undefined
    if (!allowed) {
      setAccess(true)
      return <NoPermission />
    } else {
      getAllBucketData();
      getAllCustomer();
      setFromDate(new Date(date.setDate(date.getDate() - 1)));
      setToDate(new Date());
    }
  }


  const getAllBucketData = () => {
    MixBucketProxy.GetAllBucketDetailMini((response) => {
      setAllBucketData(response);
      Constants.USER_COLUMN_PERMISSION.forEach(iColumnPermission => {
        if (iColumnPermission === "03c60e42-31d0-4b12-b8f0-d7e141ae6c28") {
          setQtyPermission(true);
        }
      })
    });
  };

  const setAllBucketData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = {
        value: data.id,
        label:
          data.stonetypefullname +
          " | " +
          data.shape +
          " | " +
          data.size +
          " | " +
          data.color +
          " | " +
          data.clarity,
      };
      optionsArray.push(option);
      return true;
    });
    setBucketOption(optionsArray);
    setBucket(bucket.length !== 0 && optionsArray.length > 0 ? [optionsArray[0]] : bucket);
    setFetchData(true);
  };

  const getAllCustomer = () => {
    UserProxy.GetAllUserDetailCustomer((response) =>
      setAllCustomerData(response)
    );
  };

  const setAllCustomerData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.id, label: data.id + " | " + data.companyname };
      optionsArray.push(option);

      return true;
    });
    setCustomerOption(optionsArray);
    setCustomer(
      customer.length !== 0 && optionsArray.length > 0 ? [optionsArray[0]] : customer
    );
  };

  useEffect(() => {
    if (fetchData) {
      if (bucket.value && customer.value && fromDate && toDate) {
        handleSearch(bucket, customer, fromDate, toDate);
      }
    }
  }, [fetchData, bucket, customer, toDate, fromDate]);

  const fullOptionToValue = (selectedData) => {
    if (selectedData.value) {
      return [selectedData.value];
    }
    let newArr = [];
    selectedData.map((option) => {
      newArr.push(option.value);
      return true;
    });
    return newArr;
  };

  const handleSearch = (bucket, customer, fromDate, toDate) => {
    let data = {
      buckets:
        fullOptionToValue(bucket).length === bucketOption.length
          ? []
          : fullOptionToValue(bucket),
      customers:
        fullOptionToValue(customer).length === customerOption.length
          ? []
          : fullOptionToValue(customer),
      from: Utility.ConvertLocalTimeToUtc(dayjs(fromDate).format('YYYY-MM-DD') + "T00:00:00.000"),
      to: Utility.ConvertLocalTimeToUtc(dayjs(toDate).format('YYYY-MM-DD') + "T23:59:59.999"),
    };
    setPurchaseListListLoader(true);
    MixPurchaseProxy.GetAllReportPurchaseByDate(data, (response) => {
      if (response) {
        const uniqueFilterValues = {
          customerid: Utility.getDistinctOptions(response, "customerid"),
        };
        const combinedFilterValues = {
          customerid: uniqueFilterValues.customerid.map(value => {
            const matchingItem = response.find(item => item.customerid === value);
            return matchingItem ? `${matchingItem.customerid} | ${matchingItem.customername}` : value;
          })
        };
        setFilterValues(combinedFilterValues);
        setSourceData(response);
        setPurchaseListListLoader(false);
        setFetchData(false);
      } else {
        setPurchaseListListLoader(false);
        setErrorSnackbar(false);
      }
    });
  };

  const columnName = [
    {
      field: "id",
      headerName: "ID",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 50,
    },
    {
      field: "bucketid",
      headerName: "BUCKET",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      type: "singleSelect",
      valueOptions: bucketOption,
      filterOperators: Utility.combinedFilters(),
      renderCell: (params) =>
        params.row.bucketid +
        " - " +
        params.row.bucketstonetypefullname +
        " | " +
        params.row.bucketshapename +
        " | " +
        params.row.bucketsizename +
        " | " +
        params.row.bucketcolorname +
        " | " +
        params.row.bucketclarityname,
    },
    {
      field: "customerid",
      headerName: "CUSTOMER COMPANY",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.customerid : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: (params) =>
        params.row.customerid + " | " + params.row.customercompanyname,
    },
    {
      field: "date",
      headerName: "CREATED AT",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      type: "date",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => {
        if (params.value) {
          return Utility.ConvertUtcToLocalDate(params.value);
        } else {
          return "";
        }
      }
    },
    {
      field: "price",
      headerName: "PPC",
      headerAlign: "center",
      align: "right",
      width: 70,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price)
    },
    {
      field: "qty",
      headerName: "QTY",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "number",
      valueFormatter: (params) => params.value,
      minWidth: 100,
    },
  ];
  const rows = sourceData;
  const columns = columnName.filter(iColumn => {
    if (iColumn.field === "qty" && !qtyPermission) return false;
    return true;
  });

  function CustomToolbar() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          alignItems: "center",
          marginHorizontal: "5px",
          "&.MuiDataGrid-toolbarContainer": {
            padding: "0px 4px !important",
          },
        }}
      >
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarExport />
        <Box sx={{ flexGrow: 1, display: { sm: "none", md: "block" } }} />
        {purchaseListListLoader ? (
          <CircularProgress size="1rem" />
        ) : (
          <Tooltip title="Reload List">
            <RefreshOutlinedIcon
              onClick={() =>
                handleSearch(bucket, customer, fromDate, toDate)
              }
              color="primary"
              fontSize="medium"
              sx={{ cursor: "pointer" }}
            />
          </Tooltip>
        )}
        <GridToolbarQuickFilter debounceMs={500} />
      </GridToolbarContainer>
    );
  }

  return (
    <div>

      <CommonSnackbar
        show={errorSnackbar}
        message={Constants.APiFailErrorMessage}
        variant={"error"}
        autoHide={Constants.SnackBarCloseTimer}
        title={"Error"}
        handleClose={() => setErrorSnackbar(false)}
      />
      {
        access ? <NoPermission /> : (
          <Box px={1}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: 2,
                width: "100%",
                my: 1,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flex: "1 1 250px",
                  minWidth: 250,
                  maxWidth: 350,
                  gap: 1,
                }}
              >
                <Typography sx={{ whiteSpace: "nowrap", minWidth: 60 }}>Bucket</Typography>
                <Box sx={{ flexGrow: 1 }}>
                  <MultiSelect
                    options={bucketOption}
                    value={bucket}
                    onChange={(e) => setBucket(e)}
                    label={"All Buckets"}
                  />
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: { xs: "100%", sm: "auto" },
                }}
              >
                <Typography sx={{ whiteSpace: "nowrap", mr: 1 }}>Customer Company</Typography>
                <Box sx={{ width: "290px" }}>
                  <Select
                    menuPlacement="auto"
                    blurInputOnSelect={false}
                    className="basic-single"
                    classNamePrefix="select"
                    menuPortalTarget={document.body}
                    styles={{
                      ...Constants.Styles,
                      control: (base) => ({
                        ...base,
                        width: "100%",
                        minHeight: "36px",
                      }),
                    }}
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.value}
                    isMulti
                    options={customerOption}
                    value={customer}
                    onChange={(selectedOption) => setCustomer(selectedOption)}
                  />
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flex: "0 1 200px",
                  minWidth: 160,
                  maxWidth: 220,
                  gap: 1,
                }}
              >
                <Typography sx={{ whiteSpace: "nowrap", minWidth: 40 }}>From</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    ampm={true}
                    renderInput={(props) => (
                      <TextField
                        {...props}
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ ...props.inputProps, readOnly: true }}
                      />
                    )}
                    value={fromDate}
                    inputFormat="DD/MM/YYYY"
                    onChange={(newValue) => {
                      const now = dayjs();
                      const fromDate = dayjs(newValue)
                        .hour(now.hour())
                        .minute(now.minute())
                        .second(now.second())
                        .millisecond(now.millisecond())
                        .toDate();
                      setFromDate(fromDate);
                    }}
                  />
                </LocalizationProvider>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flex: "0 1 200px",
                  minWidth: 160,
                  maxWidth: 220,
                  gap: 1,
                }}
              >
                <Typography sx={{ whiteSpace: "nowrap", minWidth: 20 }}>To</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    ampm={true}
                    renderInput={(props) => (
                      <TextField
                        {...props}
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ ...props.inputProps, readOnly: true }}
                      />
                    )}
                    error={false}
                    value={toDate}
                    inputFormat="DD/MM/YYYY"
                    onChange={(newValue) => {
                      const now = dayjs();
                      const toDate = dayjs(newValue)
                        .hour(now.hour())
                        .minute(now.minute())
                        .second(now.second())
                        .millisecond(now.millisecond())
                        .toDate();
                      setToDate(toDate);
                    }}
                  />
                </LocalizationProvider>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexShrink: 0,
                  mt: { xs: 1, sm: 0 },
                }}
              >
                <LoadingButton
                  loading={purchaseListListLoader}
                  variant="contained"
                  onClick={() => handleSearch(bucket, customer, fromDate, toDate)}
                  loadingPosition="start"
                  startIcon={<SearchOutlinedIcon size="large" />}
                  disabled={customerOption.length === 0 || bucketOption.length === 0}
                  sx={{ whiteSpace: "nowrap" }}
                >
                  Search
                </LoadingButton>
              </Box>
            </Box>

            <Box
              sx={{
                backgroundColor: '#fff',
                color: '#000',
                width: "100%",
                position: "relative",
                "& .MuiTablePagination-selectLabel": {
                  marginTop: "15px",
                },
                "& .MuiTablePagination-displayedRows": {
                  marginTop: "15px",
                },
                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                  fontWeight: Constants.defaultFontWeight,
                },
                "& .css-cc8tf1": {
                  fontWeight: Constants.defaultFontWeight,
                },
                height: "79vh",
              }}
            >
              <DataGridPro
                disableRowSelectionOnClick={true}
                getRowHeight={() => "auto"}
                sx={{
                  '& .MuiDataGrid-columnHeader': {
                    color: '#fff',
                    backgroundColor: 'grey',
                  },
                  "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                    py: "8px",
                  },
                  "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                    py: "15px",
                  },
                  "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                    py: "22px",
                  },

                  fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                }}
                density="compact"
                slots={{ toolbar: CustomToolbar }}
                rows={rows}
                loading={purchaseListListLoader}
                columns={columns}
                getRowId={(row) => row.id}
                initialState={{
                  columns: {
                    columnVisibilityModel: {
                      // Hide columns id, the other columns will remain visible
                      id: false,
                    },
                  },
                  pagination: {
                    paginationModel: Constants.pageSize,
                  },
                }}
                pageSizeOptions={Constants.pageSizeOptions}
                pagination
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
              />
            </Box>
          </Box>
        )
      }
    </div >
  );
};

export default MixReportPurchaseMaster;
